export default __webpack_public_path__ + "static/media/GC_4.c94eeca3.png";